import YYPrivateTable from './table'
export default YYPrivateTable